import { z } from "zod";

export enum RatingType {
  Numbers = "numbers",
  Stars = "stars",
  Smiley = "smiley",
}

export const satisfactionFormLanguageVariantSchema = z.object({
  rating_title: z.string(),
  rating_label: z.string(),
  feedback_button: z.string(),
  thank_you_message: z.string(),
  text_feedback_title: z.string(),
  text_feedback_label: z.string(),
  text_feedback_placeholder: z.string(),
  text_feedback_button: z.string(),
  feedback_thank_you_message: z.string(),
});

export const satisfactionFormInactivityTriggerSchema = z.object({
  type: z.literal("inactivity"),
  params: z.object({
    delay: z.number(),
    excluded_response_cuids: z.array(z.string()),
  }),
});

export const satisfactionFormButtonClickTriggerSchema = z.object({
  type: z.literal("button_click"),
  params: z.object({
    delay: z.number(),
    button_types: z.array(z.string()),
    button_cuids: z.array(z.string()),
  }),
});

export const satisfactionFormResponseTriggerSchema = z.object({
  type: z.literal("response"),
  params: z.object({
    delay: z.number(),
    response_types: z.array(z.string()),
    response_cuids: z.array(z.string()),
  }),
});

export const satisfactionFormLivechatEndOfConversationTriggerSchema = z.object({
  type: z.literal("livechat_end_of_conversation"),
  params: z.object({
    delay: z.number(),
  }),
});

export const satisfactionFormTriggerSchema = z.discriminatedUnion("type", [
  satisfactionFormInactivityTriggerSchema,
  satisfactionFormButtonClickTriggerSchema,
  satisfactionFormResponseTriggerSchema,
  satisfactionFormLivechatEndOfConversationTriggerSchema,
]);

export const satisfactionFormSchema = z.object({
  cuid: z.string(),
  orchestrator_cuid: z.string(),
  version_cuid: z.string(),
  name: z.string(),
  rating_type: z.nativeEnum(RatingType),
  enable_text_feedback: z.boolean(),
  redirection_bad_rating: z.boolean(),
  language_variants: z.record(z.string(), satisfactionFormLanguageVariantSchema),
  triggers: z.array(satisfactionFormTriggerSchema),
});

export type SatisfactionFormLanguageVariant = z.infer<typeof satisfactionFormLanguageVariantSchema>;
export type SatisfactionFormTrigger = z.infer<typeof satisfactionFormTriggerSchema>;
export type SatisfactionForm = z.infer<typeof satisfactionFormSchema>;
